import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { MessageBox } from 'element-ui'
import 'animate.css';
import AnimateOnScroll from './directives/animateOnScroll.js';

Vue.config.productionTip = false

//引入elm提示框
Vue.prototype.$confirm = MessageBox.confirm;

//引入axios
import axios from 'axios' //引入axios
Vue.prototype.$axios = axios


//引入ele
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.directive('animate-on-scroll', AnimateOnScroll);

//引入iconfont
import '@/assets/fonts/iconfont.css';

//引入基础样式
import '@/assets/style/base.css';


//引入全局方法11
import '@/utils/global.js';




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


